exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".galeria[data-v-d88bc780] {\n  overflow: hidden;\n  position: relative;\n  border-radius: 6px;\n}\n.galeria a.galeria-foto[data-v-d88bc780] {\n  width: 100%;\n  display: block;\n  position: relative;\n}\n.galeria a.galeria-foto .mdi[data-v-d88bc780] {\n  display: none;\n  top: 50%;\n  left: 50%;\n  width: 70px;\n  color: rgba(255, 255, 255, 0.8);\n  height: 70px;\n  margin: -35px 0px 0px -35px;\n  position: absolute;\n  font-size: 70px;\n  line-height: 70px;\n}\n.galeria a.galeria-foto:hover .mdi[data-v-d88bc780] {\n  display: block;\n}\n.galeria a.galeria-foto img[data-v-d88bc780] {\n  display: block;\n}", ""]);

// exports
